<!--选择打印 -->
<template>
    <el-row class="main-box">
		<!-- v-print="printOption" -->
        <el-col>
				<el-image v-if="type==1" class="main-box-bg" src="https://language-training.oss-cn-hangzhou.aliyuncs.com/frontImage/image4.jpg" fit="scale-down"
				    :lazy="true"></el-image>
				
				<div :class="type==1?'listdivcls':'listdivcls2'" class="flex-column"  >
				  <div class="flex-row" style="padding-bottom: 24px;">
					<div :class="checkstate==1?'selecte1':'selecte0'" @click="selecttype(1)">打印中英文</div>
					<div :class="checkstate==2?'selecte1':'selecte0'" style="margin-left: 15px;" @click="selecttype(2)">打印英文</div>
					<div :class="checkstate==3?'selecte1':'selecte0'" style="margin-left: 15px;" @click="selecttype(3)">打印中文</div>
					<div :class="checkstate==4?'selecte1':'selecte0'" style="margin-left: 15px;" @click="selecttype(4)">打印音标</div>
					
					<div class="selecte1" style="margin-left: 15px;background: #ACBEB0;" @click="backclick()">返回</div>
					<div class="selecte0" style="margin-left: 15px;border: 2px solid #0AA26B;background: #fff;" v-print="printOption">打印</div>
				  </div>
				  
				  
				  <div class="nbprintcls flex-column" id="nbprint">
					<div  class="flex-row divbeij f-align-center">
						<span>学员:</span>
						<span style="margin-left: 4px;color: #333333;">{{data.studentName}}</span>
						
						<span style="margin-left: 100px;">打印时间:</span>
						<span style="margin-left: 4px;color: #333333;">{{data.printDate}}</span>
					</div>
					
					<div class="dayheadcls">
						<div class="dayheadcls1 flex-row f-justify-between">
							<div style="color: #fff;flex: 1;text-align: center;" v-for="(cidata, indexci) in day" :key="indexci">
								{{indexci==0?'上课次数':cidata+""}}</div>
						</div>
						<div class="flex-row f-justify-between flex1" >
							<div style="color: #0AA26B;flex: 1;text-align: center;font-weight: bold;">
								上课时间</div>
							<div style="color: #333333;flex: 1;text-align: center;" v-for="(cidata, indexci) in data.amnesic21PrintDateListBatchVos" :key="indexci">
								{{cidata.amnesicDate}}</div>
						</div>
						<div class="flex-row f-justify-between flex1" >
							<div style="color: #0AA26B;flex: 1;text-align: center;font-weight: bold;">
								单词数</div>
							<div style="color: #333333;flex: 1;text-align: center; " v-for="(cidata, indexci) in data.amnesic21PrintDateListBatchVos"
							 :key="indexci">
							 <span style="cursor: pointer;">
								<el-checkbox  @change="handleCheckAllChange" v-if="cidata.amnesicCount&&cidata.amnesicCount!=0" 
								 v-model="cidata.ischecked"
								 >{{cidata.amnesicCount==0?'':cidata.amnesicCount}}</el-checkbox>
								</span>
								</div>
						</div>
					</div>
					
				<!-- 
					chinese	string
					单词中文
					phonetic	string
					音标
					word	string
					单词英文 -->
					
					
					<div class="gridcls" style="page-break-after:always">
						<div class="daycls1 flex-column"  v-for="(cidata, indexci) in datalist" :key="indexci">
							<!-- <div style="color: #fff;flex: 1;text-align: center;" v-for="(cidata, indexci) in day" :key="indexci">
								{{indexci==0?'天数':'第'+(cidata)+'天'}}</div> -->
						<div v-if="cidata.length>0" class="flex-row f-align-center" style="height: 50px;">
								<div  class="contencls2 flex1">{{checkstate==3?'':cidata[0].word}}</div>
								<div  :class="isselectred(cidata[0].word)?'linecls2':'linecls1'"></div>
								<div class="contencls flex1" :class="checkstate==4?'myzit':''">{{checkstate==2?'':checkstate==4?cidata[0].phonetic:cidata[0].chinese}}</div>
							</div>	
						<div  v-if="cidata.length>1" class="flex-row f-align-center" style="height: 50px;">
								<div class="contencls2 flex1">{{checkstate==3?'':cidata[1].word}}</div>
									<div  :class="isselectred(cidata[1].word)?'linecls2':'linecls1'"></div>
									<div class="contencls flex1" :class="checkstate==4?'myzit':''">{{checkstate==2?'':checkstate==4?cidata[1].phonetic:cidata[1].chinese}}</div>
									</div>	
							
							<div v-if="cidata.length>2" class="flex-row f-align-center" style="height: 50px;">
						<div class="contencls2 flex1">{{checkstate==3?'':cidata[2].word}}</div>
							<div  :class="isselectred(cidata[2].word)?'linecls2':'linecls1'"></div>
							<div class="contencls flex1" :class="checkstate==4?'myzit':''">{{checkstate==2?'':checkstate==4?cidata[2].phonetic:cidata[2].chinese}}</div>
							</div>	
							<div v-if="cidata.length>3"  class="flex-row f-align-center" style="height: 50px;">
						<div class="contencls2 flex1">{{checkstate==3?'':cidata[3].word}}</div>
							<div  :class="isselectred(cidata[3].word)?'linecls2':'linecls1'"></div>
							<div class="contencls flex1" :class="checkstate==4?'myzit':''">{{checkstate==2?'':checkstate==4?cidata[3].phonetic:cidata[3].chinese}}</div>
							</div>	
							<div v-if="cidata.length>4"  class="flex-row f-align-center" style="height: 50px;">
						<div class="contencls2 flex1">{{checkstate==3?'':cidata[4].word}}</div>
							<div  :class="isselectred(cidata[4].word)?'linecls2':'linecls1'"></div>
							<div class="contencls flex1" :class="checkstate==4?'myzit':''">{{checkstate==2?'':checkstate==4?cidata[4].phonetic:cidata[4].chinese}}</div>
						</div>	
						</div>
					</div>
					<div class="gridcls1" style="page-break-after:always" v-for="(edcidata, edindexci) in edatalist" :key="edindexci">
						<div class="daycls1 flex-column"  v-for="(cidata, indexci) in edcidata" :key="indexci">
							<!-- <div style="color: #fff;flex: 1;text-align: center;" v-for="(cidata, indexci) in day" :key="indexci">
								{{indexci==0?'天数':'第'+(cidata)+'天'}}</div> -->
						<div v-if="cidata.length>0" class="flex-row f-align-center" style="height: 50px;">
								<div class="contencls2 flex1">{{checkstate==3?'':cidata[0].word}}</div>
								<div  :class="isselectred(cidata[0].word)?'linecls2':'linecls1'"></div>
								<div class="contencls flex1" :class="checkstate==4?'myzit':''">{{checkstate==2?'':checkstate==4?cidata[0].phonetic:cidata[0].chinese}}</div>
							</div>	
						<div  v-if="cidata.length>1" class="flex-row f-align-center" style="height: 50px;">
								<div class="contencls2 flex1">{{checkstate==3?'':cidata[1].word}}</div>
									<div  :class="isselectred(cidata[1].word)?'linecls2':'linecls1'"></div>
									<div class="contencls flex1" :class="checkstate==4?'myzit':''">{{checkstate==2?'':checkstate==4?cidata[1].phonetic:cidata[1].chinese}}</div>
									</div>	
							
							<div v-if="cidata.length>2" class="flex-row f-align-center" style="height: 50px;">
						<div class="contencls2 flex1">{{checkstate==3?'':cidata[2].word}}</div>
							<div  :class="isselectred(cidata[2].word)?'linecls2':'linecls1'"></div>
							<div class="contencls flex1" :class="checkstate==4?'myzit':''">{{checkstate==2?'':checkstate==4?cidata[2].phonetic:cidata[2].chinese}}</div>
							</div>	
							<div v-if="cidata.length>3"  class="flex-row f-align-center" style="height: 50px;">
						<div class="contencls2 flex1">{{checkstate==3?'':cidata[3].word}}</div>
							<div  :class="isselectred(cidata[3].word)?'linecls2':'linecls1'"></div>
							<div class="contencls flex1" :class="checkstate==4?'myzit':''">{{checkstate==2?'':checkstate==4?cidata[3].phonetic:cidata[3].chinese}}</div>
							</div>	
							<div v-if="cidata.length>4"  class="flex-row f-align-center" style="height: 50px;">
						<div class="contencls2 flex1">{{checkstate==3?'':cidata[4].word}}</div>
							<div  :class="isselectred(cidata[4].word)?'linecls2':'linecls1'"></div>
							<div class="contencls flex1 " :class="checkstate==4?'myzit':''" >{{checkstate==2?'':checkstate==4?cidata[4].phonetic:cidata[4].chinese}}</div>
						</div>	
						</div>
					</div>
					
					
				  </div>
				</div>
        </el-col>

    </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
	
    data() {
        return {
			printOption:{
						id: 'nbprint', // 打印元素的id 不需要携带#号
						preview: false, // 开启打印预览
						zIndex:2002,
						
									previewTitle: '打印预览', // 打印预览标题
									// popTitle: '员工信息', // 页眉标题 默认浏览器标题 空字符串时显示undefined 使用html语言
				                      // 头部文字 默认空 在节点中添加 DOM 节点， 并用,(Print local range only)分隔多个节点
									// extraHead:'https://***/***.css, https://***/***.css', 
				                      // 新的 CSS 样式表， 并使用,（仅打印本地范围）分隔多个节点
									// extraCss: '<meta http-equiv="Content-Language"content="zh-cn"/>',
									previewBeforeOpenCallback: () => {
										console.log("触发打印预览打开前回调");
									},
									previewOpenCallback: () => {
										console.log("触发打开打印预览回调");
									},
									beforeOpenCallback: () => {
										console.log("触发打印工具打开前回调");
									},
									openCallback: () => {
										console.log("触发打开打印工具回调");
									},
									closeCallback: () => {
										console.log("触发关闭打印工具回调");
									},
									clickMounted: () => {
										console.log("触发点击打印回调");
									}
			},
			data:{},
			datalist:[
			],
			edatalist:[
				
			],
			day:[
				'',
				'本次',
				'前1次',
				'前2次',
				'前3次',
				'前4次',
				'前5次',
				'前6次',
				'前7次',
				'前8次',
				'前9次',
			],
			id:"",
			checkstate:1,
			redata:[],
			type:0,
			check:true,
        }
    },
   computed: {
      ...mapState([
          'userToken',
		   'userInfos',
      ]),
      ...mapGetters(["getUserToken"])
    },
	created() {
		this.id = decodeURIComponent(this.$route.query.id);
	    this.getdata();
	},
    methods: {
		  handleCheckAllChange(val) {
		        // this.checkedCities = val ? cityOptions : [];
		        // this.isIndeterminate = false;
				console.log("~~~~~"+val);
				var amnesic21PrintDateListBatchVoslist= this.data.amnesic21PrintDateListBatchVos;
				var datlistmy=[];
				for(var i=0;i<amnesic21PrintDateListBatchVoslist.length;i++)
				{
					if(amnesic21PrintDateListBatchVoslist[i].ischecked)
					{
						console.log("~~~~amnesic21PrintDateListBatchVoslist[i].amnesic21PrintWordDetailVos:"+amnesic21PrintDateListBatchVoslist[i].amnesic21PrintWordDetailVos.length);
						datlistmy.push(...amnesic21PrintDateListBatchVoslist[i].amnesic21PrintWordDetailVos);
					}
				}
				console.log("~~~~datlistmy:"+datlistmy.length);
				this.datalist=[];
				this.edatalist=[];
				var amnesic21PrintWordDetailVos= datlistmy.filter((item) => item!=null);
					console.log("~~~~amnesic21PrintWordDetailVos:"+amnesic21PrintWordDetailVos.length);
					if(amnesic21PrintWordDetailVos!=null&&amnesic21PrintWordDetailVos.length>0)
					{
						
						if(amnesic21PrintWordDetailVos.length<=5)
						{
							this.datalist.push(amnesic21PrintWordDetailVos);
						}else{
							var lenght=Math.ceil(amnesic21PrintWordDetailVos.length/5);
							
							var datalistcpy=[];
							for(var i=0;i<lenght;i++)
							{
								if(i+1==lenght)
								{
									datalistcpy[i]=amnesic21PrintWordDetailVos.slice(i*5,amnesic21PrintWordDetailVos.lenght);
								}else{
									datalistcpy[i]=amnesic21PrintWordDetailVos.slice(i*5,(i+1)*5);
								}
							}
							
							if(datalistcpy.length<=10)
							{
								this.datalist=datalistcpy;
							}else{
								this.datalist=datalistcpy.slice(0,10);
								var datalistcpy2=datalistcpy.slice(10,datalistcpy.length);
								var lenght=Math.ceil(datalistcpy2.length/15);
								
								for(var i=0;i<lenght;i++)
								{
									if(i+1==lenght)
									{
										this.edatalist[i]=datalistcpy2.slice(i*15,datalistcpy2.lenght);
									}else{
										this.edatalist[i]=datalistcpy2.slice(i*15,(i+1)*15);
									}
								}
							}
						}
					}
		      },
		selecttype(type){
			this.checkstate=type;
			if(this.checkstate==1)
			{
					document.title="中英文";
			}else if(this.checkstate==2)
			{
					document.title="英文";
			}else if(this.checkstate==3)
			{
					document.title="中文";
			}else if(this.checkstate==4)
			{
					document.title="音标";
			}
		},
		isselectred(word){
			for(var i=0;i<this.redata.length;i++)
			{
				if(word==this.redata[i].word)
				{
					return true;
				}
			}
			return false;
		},
	async	clickwnum(amnesicDate,amnesicCount){
		if(amnesicCount==0||!amnesicCount)
		{
			return;
		}
			this.redata=[];
		var url="/web/teacher/home/classSalesRecordPrintAmnesicList";
		  let res = await this.$api.get(url, {
		      headers: { //头部参数
		          frontUserToken: this.getUserToken
		      },
			  params:{
			  	id:this.id,
				amnesicDate:amnesicDate
			   }
		  });
		if(res.code==200)
		{
			this.redata=res.data;
		}	
		},
      async getdata() {
      	var url="/web/student/home/classSalesRecordPrintBatch";
          let res = await this.$api.get(url, {
              headers: { //头部参数
                  frontUserToken: this.getUserToken
              },
			  params:{
			  	id:this.id,
			   }
          });
      	if(res.code==200)
      	{
      		this.data=res.data;
			for(var i=0;i<this.data.amnesic21PrintDateListBatchVos.length;i++)
			{
				this.data.amnesic21PrintDateListBatchVos[i].ischecked=false;
			}
		   }
		   },
		backclick(){
			this.$router.back();
		}
    }
}
</script>

<style lang="scss" scoped>
	  @import '../../font.css';
	@page {
		size: landscape;
	    // size: auto;
	    margin: 0mm;
	  }
	
	  .contencls{
		 color: #333333;text-align: center;text-overflow: ellipsis;
		 white-space: nowrap;
		 overflow: hidden; 
	  }
	.contencls1{
			 text-align: center;text-overflow: ellipsis;
			 font-weight: bold;
			 white-space: nowrap;
			 overflow: hidden; 
	}
	
	.contencls2{
			 text-align: center;
			 font-weight: bold;
			 overflow: hidden; 
			 word-break:break-all;
		
			 line-height:18px;
	}
	
	
	.linecls1{
		border-right: 1px solid #ACBEB0;height: 21px;
	}
	.linecls2{
		border-right: 2px solid red;height: 21px;
	}
	
.main-box {
    width: 100%;
	flex: 1;
    position: relative;
	 background: #E5F3F1;
}
    .main-box-bg {
        width: 100%;
        // height: 230px;
        position: relative;
        top: 0;
        left: 0;
    }
	

.listdivcls{
	  width: 1340px;
	  position: relative;
	  border-radius: 20px;
	  background: #FFFFFF;
	  margin: 0 auto;
	  padding: 30px;
	  top: -23px;
	  @media screen and (max-width: 768px) {
	      top: -15px;
	  }
	}
	
	.listdivcls2{
		  width: 1340px;
		  border-radius: 20px;
		  background: #FFFFFF;
		  margin: 0 auto;
		  padding: 30px;
		  margin-top: 20px;
		  margin-bottom: 20px;
		}
	
.nbprintcls{
	width: 1260px;
	-webkit-print-color-adjust: exact;
	}
	
	
.selecte1,.selecte0{
		width: 134px;
		height: 46px;
		border-radius: 100px;
		opacity: 1;
		background: #0AA26B;
		font-family: Source Han Sans CN;
		font-size: 18px;
		font-weight: bold;
		line-height: 46px;
		text-align: center;
		letter-spacing: 0em;
		text-align: center;
		font-feature-settings: "kern" on;
		color: #FFFFFF;
		cursor:pointer;
	}
	.selecte0{
			background: rgba(10, 162, 107, 0.2);
		color: #0AA26B;
		}
		
		.selecte1:hover{
			background: #ccc;;	
		}
		.selecte0:hover{
			background: #ccc;;	
		}
	
.divbeij{
	margin-top: 10px;
		width: 767px;
		height: 44px;
		border-radius: 20px;
		opacity: 1;
		background: linear-gradient(276deg, #F8FFFC -18%, #D9F1E5 100%);
		box-shadow: 0px 0px 10px 0px rgba(145, 170, 158, 0.1);
		
		font-family: Source Han Sans CN;
		font-size: 16px;
		font-weight: normal;
		line-height: 30px;
		letter-spacing: 0em;
		
		font-feature-settings: "kern" on;
		/* 灰 */
		color: #ACBEB0;
		padding-left: 21px;
		-webkit-print-color-adjust: exact;
	}
.dayheadcls{
		height: 194px;
		border-radius: 20px;
		opacity: 1;
		margin-top: 20px;
		background: #E5F7F1;
		box-sizing: border-box;
		border: 1px solid rgba(10, 162, 107, 0.2);
		font-family: 思源黑体;
		font-size: 16px;
		line-height: 60px;
		letter-spacing: 0em;
		font-feature-settings: "kern" on;
		color: #0AA26B;
		padding: 10px;
		
	
		
	}
	.dayheadcls1{
			height: 55px;
			border-radius: 10px;
			background: #0AA26B;
		}

.daycls1{
		width: 232px;
		height: 270px;
		border-radius: 20px;
		background: #E5F7F1;
		box-sizing: border-box;
		border: 1px solid rgba(10, 162, 107, 0.2);
		font-family: 思源黑体;
		font-size: 16px;
		line-height: 60px;
		letter-spacing: 0em;
		font-feature-settings: "kern" on;
		color: #0AA26B;
		padding-top: 10px;
		padding-bottom: 10px;
	}
	
	.gridcls{
		display: grid;
		grid-template-columns: repeat(auto-fill, 232px);
		justify-content: space-between;
		margin-top: 30px;
		gap: 15px 0;
	}
	.gridcls1{
		display: grid;
		grid-template-columns: repeat(auto-fill, 232px);
		justify-content: space-between;
		margin-top: 15px;
		gap: 15px 0;
	}
	
	.myzit{
		font-family: myfont;
	}
</style>